import { http } from '@/shared/api/client';
import type { MgmCodeInfo, MgmParticipantView } from '../model/types';

/**
 * Rotas PÚBLICAS do Indique e Ganhe no BFF (`/bff/public/mgm/*`), sem sessão.
 * O BFF fala com a legacy-api com o segredo `X-Mgm-Key`, aplica rate limit e
 * nunca registra o identificador do cliente em log.
 */

const PREFIX = '/bff/public/mgm';

/** Página do participante (dentro do app). O CPF vai no corpo, nunca na URL. */
export function fetchParticipantView(idPassbook: string, uniqueId: string): Promise<MgmParticipantView> {
  return http.post<MgmParticipantView>(`${PREFIX}/${encodeURIComponent(idPassbook)}/me`, { uniqueId });
}

/** Convite: quem indicou e o benefício de quem entra. */
export function fetchCodeInfo(code: string): Promise<MgmCodeInfo> {
  return http.get<MgmCodeInfo>(`${PREFIX}/r/${encodeURIComponent(code)}`);
}

/**
 * "Indicada": o visitante do link se identificou no formulário. Fire-and-forget
 * do ponto de vista da tela — o cadastro segue igual com ou sem resposta.
 */
export async function claimReferral(input: { idPassbook: string; code: string; uniqueId: string }): Promise<void> {
  try {
    await http.post(`${PREFIX}/claim`, input);
  } catch {
    /* o cadastro não depende do claim; o hook do register refaz com o código */
  }
}
